import React from 'react';
import { UserRole, UserRoleValue } from './UserRole';
import { Api } from './rest-api/api-exports';
import { getGeoRequest } from './rest-api/api-requests';
import moment from 'moment';
import { defaultSpecialWorkTime } from './work-time-pharmacy/weekdays';

export const regExEmail = () =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const regExPhone = () => /^(?=.*[0-9])[- +()0-9]+$/;

export const getRoleValueHandler = roleValue => {
    switch (roleValue) {
        case UserRole.STORE_OWNER:
            return UserRoleValue.STORE_OWNER;
        case UserRole.PHARMACY_MANAGER:
            return UserRoleValue.PHARMACY_MANAGER;
        case UserRole.PHARMACIST:
            return UserRoleValue.PHARMACIST;
        default:
            return;
    }
};

export const getRoleHandler = roleValue => {
    switch (roleValue) {
        case UserRoleValue.STORE_OWNER:
            return UserRole.STORE_OWNER;
        case UserRoleValue.PHARMACY_MANAGER:
            return UserRole.PHARMACY_MANAGER;
        case UserRoleValue.PHARMACIST:
            return UserRole.PHARMACIST;
        default:
            return;
    }
};

export const generateUserRole = status => {
    let roles = [];
    switch (status) {
        case UserRole.ADMIN:
            roles = [
                { title: UserRole.STORE_OWNER, value: UserRoleValue.STORE_OWNER },
                { title: UserRole.PHARMACY_MANAGER, value: UserRoleValue.PHARMACY_MANAGER },
                { title: UserRole.PHARMACIST, value: UserRoleValue.PHARMACIST }
            ];
            return roles;

        case UserRole.STORE_OWNER:
            return (roles = [
                { title: UserRole.PHARMACY_MANAGER, value: UserRoleValue.PHARMACY_MANAGER },
                { title: UserRole.PHARMACIST, value: UserRoleValue.PHARMACIST }
            ]);

        case UserRole.PHARMACY_MANAGER:
            return (roles = [{ title: UserRole.PHARMACIST, value: UserRoleValue.PHARMACIST }]);

        default:
            
    }
};

export const generateOptions = (types, data) => {
    switch (types) {
        case 'role':
            return (generateUserRole(data.status) || []).map(role => (
                <option key={role.title} value={role.value}>
                    {role.title}
                </option>
            ));
        case 'company':
            return (data.companyList || []).map(company => (
                <option key={company.id} value={company.id}>
                    {company.name}
                </option>
            ));
        case 'pharmacy':
            return (data.pharmacyList || []).map(pharmacy => (
                <option key={pharmacy.id} value={pharmacy.id}>
                    {pharmacy.name}
                </option>
            ));
        default:
    }
};

export const formatDate = (date, hasYear) => {
    let newDate = new Date(date),
        day = newDate.getDate(),
        month = newDate.getMonth() + 1,
        year = newDate.getFullYear(),
        formatted = '';
    
    if (day < 10) {
        formatted += '0' + day + '/';
    } else {
        formatted += day + '/';
    }

    if (month < 10) {
        formatted += '0' + month;
    } else {
        formatted += month;
    }

    if (hasYear) {
        formatted += '/' + year;
    }

    return formatted;
};

export const formatHolidayDate = (date, format) => {
    let newDate = moment(date, format),
        day = newDate.date(),
        month = newDate.month() + 1;

    return day + '/' + month;
}

//Fetch latitude and longitude
export const geoCodeAddress = address => {
    let url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=AIzaSyDsW0QYQKqkoFzkzykwKY3gyMWPehZnc2c';
    return getGeoRequest(url);
};

export const getCoordiantes = address => {
    return Api.Address.coordinates(address)
        .then(res => res)
        .catch(err => err);
};

export const dayAbbreviation = day => {
    switch (day) {
        case 'monday':
            return 'mon';
        case 'tuesday':
            return 'tue';
        case 'wednesday':
            return 'wed';
        case 'thursday':
            return 'thu';
        case 'friday':
            return 'fri';
        case 'saturday':
            return 'sat';
        case 'sunday':
            return 'sun';
        default:
    }
};

export const todayDayAbbreviation = () => {
    let todayDay = new Date().getDay().toString();

    switch (todayDay) {
        case '1':
            return 'mon';
        case '2':
            return 'tue';
        case '3':
            return 'wed';
        case '4':
            return 'thu';
        case '5':
            return 'fri';
        case '6':
            return 'sat';
        case '0':
            return 'sun';
        default:
    }
};

export const workTimeSelectOptions = () => {
    const interval = 15;

    let timeArr = [];
    let currentTime = 0;

    for (let i = 0; currentTime < 24 * 60; i++) {
        let hh = Math.floor(currentTime / 60);
        let mm = currentTime % 60;

        timeArr[i] = ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2);

        currentTime += interval;
    }
    return timeArr.map(item => (
        <option value={item} key={item}>
            {item}
        </option>
    ));
};

export const cloneObject = originalObject => {
    return JSON.parse(JSON.stringify(originalObject));
};

export const calculateRotation = (rotate, direction) => {
    if (Math.abs(rotate) + 90 === 360) {
        return 0;
    } else if (direction === 'ccw') {
        return rotate - 90;
    } else if (direction === 'cw') {
        return rotate + 90;
    }
};

export const unitAbbr = unit => {
    switch (unit) {
        case 'grams':
            return 'g';
        case 'milliliters':
            return 'ml';
        case 'micrograms':
            return 'μg';
        case 'milligrams':
            return 'mg';
        case 'litre':
            return 'L';
        default:
            return '';
    }
};

export const prepareHolidays = holidays => {
    holidays.forEach((holiday, _index) => {
        if (holiday.workTime === undefined) {
            holiday.workTime = [];
        }

        let hoursArrayLength = holiday.workTime.length;

        if (hoursArrayLength === 0) {
            holiday.workTime = defaultSpecialWorkTime;
            holiday.lunchBreak = true;
            holiday.dayOff = true;
        }
        if (hoursArrayLength === 1) {
            holiday.workTime[1] = { "from":"13:30", "to":"17:00" };
            holiday.lunchBreak = false;
            holiday.dayOff = false;
        }
        if (hoursArrayLength === 2) {
            holiday.lunchBreak = true;
            holiday.dayOff = false;
        }
    });

    return holidays;
};



// WEBPACK FOOTER //
// ./src/customModules/Common/Helpers.js